import { Box, Typography, styled } from "@mui/material";
import { ReactNode } from "react";

const BannerContainer = styled(Box)(() => ({
    background: "rgba(8, 57, 98, 0.05)",
    border: "1px dashed #083962",
    borderRadius: "16px",
    padding: "32px",
    textAlign: "center",
    marginBottom: "32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "200px",
    width: "100%",
}));

interface UnderConstructionProps {
    children: ReactNode;
}

export const UnderConstruction = ({ children }: UnderConstructionProps) => {
    return (
        <BannerContainer>
            <Typography variant="h5" sx={{ color: "#083962", fontWeight: 600, mb: 2 }}>
                Страница находится в разработке
            </Typography>
            <Typography variant="body1" sx={{ color: "#555", maxWidth: "600px" }}>
                {children}
            </Typography>
        </BannerContainer>
    );
};
